import { usePhrase } from '@/hooks';
import React from 'react';
import { VerificationInfo } from '@/types/types';
import { SkeletonBlock } from '@/components/general/skeletonBlock/SkeletonBlock';
import { VERIFICATION_PHRASES } from '@/consts/phrases/verificationPhrases';
import { JSXFromString } from '@/utils';
import { isTypeOfBool } from '@/utils/fp';

const getHeaderPhraseId = (verificationInfo: VerificationInfo): number | undefined => {
    if (isTypeOfBool(verificationInfo?.isIsoPhysician)) {
        return verificationInfo?.isIsoPhysician
            ? VERIFICATION_PHRASES.HEADER_ISO_PHYSICIAN
            : VERIFICATION_PHRASES.HEADER_NON_ISO_PHYSICIAN;
    }
    return undefined;
};

interface HeaderProps {
    verificationInfo: VerificationInfo;
}

export const Header = (props: HeaderProps) => {
    const { t } = usePhrase();
    return <>{JSXFromString(t(getHeaderPhraseId(props.verificationInfo)))}</>;
};

export const HeaderSkeleton = () => <SkeletonBlock amount={3} />;
